import React from 'react';
import {
  Box,
  Button,
  HeadingText,
  Modal,
  ParagraphText,
  StackLayout,
  queryHelpers,
  useMediaQuery,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import accountDeactivatedIllustration from 'assets/im-account-deactivated.svg';

interface AccountDeactivatedDialogProps {
  onClose: () => void;
}

export const AccountDeactivatedDialog = ({
  onClose,
}: AccountDeactivatedDialogProps) => {
  const { formatMessage } = useIntl();
  const isMobile = useMediaQuery(queryHelpers.down('tablet'));

  return (
    <Modal.Root
      open
      onOpenChange={(open: boolean) => {
        if (!open) onClose();
      }}
    >
      <Modal.Content
        width={{
          '@initial': '716px',
          '@mobile': '100%',
          '@mobileLandscape': '100%',
        }}
        padding="$half"
      >
        {/* Body */}
        <StackLayout
          spacing="$one"
          css={{ paddingLeft: '$one', paddingRight: '$one' }}
        >
          <Box
            as="img"
            src={accountDeactivatedIllustration}
            alt=""
            width={176}
            height={176}
            css={{
              alignSelf: 'center',
              marginTop: isMobile ? '$half' : '$two',
            }}
          />
          <Modal.Title asChild>
            <HeadingText
              size="md"
              level="2"
              css={{ color: '$onSurfaceTextPrimary' }}
            >
              {formatMessage({ id: 'STR_ACCOUNT_DEACTIVATED_TITLE' })}
            </HeadingText>
          </Modal.Title>
          {/* TODO: PTTH-XXX — replace with formatMessage({ id: 'STR_ACCOUNT_DEACTIVATED_DESCRIPTION' })
              once final copy is confirmed and added to en.json */}
          <ParagraphText
            css={{ color: '$onSurfaceTextPrimary', marginBottom: '$two' }}
          >
            Lorem ipsum dolor sit amet consectetur. Enim suspendisse ipsum et
            pellentesque lacus at pellentesque. Maecenas turpis non nulla
            mauris. Tellus consequat hendrerit est sit tristique orci. Et
            facilisis dignissim.
          </ParagraphText>
          <StackLayout
            orientation="horizontal"
            horizontalAlignment="end"
            css={{ width: '100%', marginBottom: '$half' }}
          >
            <Button
              type="button"
              priority="primary"
              width={isMobile ? 'fillContainer' : undefined}
              onClick={onClose}
            >
              {formatMessage({ id: 'STR_I_UNDERSTAND' })}
            </Button>
          </StackLayout>
        </StackLayout>
      </Modal.Content>
    </Modal.Root>
  );
};
